class ForecastRouting {
  routingSystem: 'SEPA' | 'Swift';
  routingDescription: string;
  routingSn: number;

  constructor(routingSystem: 'SEPA' | 'Swift', routingDescription: string, routingSn: number) {
    this.routingSystem = routingSystem;
    this.routingDescription = routingDescription;
    this.routingSn = routingSn;
  }
}

export { ForecastRouting };
